"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var MomentUtils_1 = require("./MomentUtils");
var Formats = {
    date: "YYYY-MM-DD",
    timestampNoTimezone: "YYYY-MM-DD[T]HH:mm:ss.SSS",
    timestampOut: "DD/MM/YYYY HH:mm:ss"
};
exports.Formats = Formats;
var momentFromDataString = function (value) {
    return MomentUtils_1.momentFromString(value, Formats.date);
};
exports.momentFromDataString = momentFromDataString;
var momentToDataString = function (value) {
    return MomentUtils_1.momentToString(value, Formats.date);
};
exports.momentToDataString = momentToDataString;
var momentToTimestampDataString = function (value, withTimezone) {
    if (withTimezone === void 0) { withTimezone = true; }
    if (withTimezone) {
        return MomentUtils_1.momentToISOString(value);
    }
    return MomentUtils_1.momentToString(value, Formats.timestampNoTimezone);
};
exports.momentToTimestampDataString = momentToTimestampDataString;
var momentFromTimestampDataString = function (value, keepTimezone) {
    if (keepTimezone === void 0) { keepTimezone = false; }
    if (value) {
        if (keepTimezone) {
            // Keep the moment object in the timezone specified in 'value' string
            return moment.parseZone(value, moment.ISO_8601, true);
        }
        // Shift the timezone to client timezone (default moment behaviour)
        return moment(value, moment.ISO_8601, true);
    }
    return undefined;
};
exports.momentFromTimestampDataString = momentFromTimestampDataString;
var timestampIO = function (value, outFormat) {
    if (outFormat === void 0) { outFormat = Formats.timestampOut; }
    return MomentUtils_1.momentToString(momentFromTimestampDataString(value), outFormat);
};
exports.timestampIO = timestampIO;
